export function getFareDetails({ booking, carTypeObj, settings, t, getLangKey }) {
  if (!carTypeObj) return [];
  return [
    { key: 'base_fare', label: t('base_fare'), value: settings.swipe_symbol ? `${formatAmount(carTypeObj.base_fare, settings.decimal, settings.country)} ${settings.symbol}` : `${settings.symbol} ${formatAmount(carTypeObj.base_fare, settings.decimal, settings.country)}` },
    { key: 'rate_per_unit_distance', label: t('rate_per_unit_distance'), value: settings.swipe_symbol ? `${formatAmount(carTypeObj.rate_per_unit_distance, settings.decimal, settings.country)} ${settings.symbol}/${settings.convert_to_mile ? t('mile') : t('km')}` : `${settings.symbol} ${formatAmount(carTypeObj.rate_per_unit_distance, settings.decimal, settings.country)}/${settings.convert_to_mile ? t('mile') : t('km')}` },
    { key: 'rate_per_hour', label: t('rate_per_hour'), value: settings.swipe_symbol ? `${formatAmount(carTypeObj.rate_per_hour, settings.decimal, settings.country)} ${settings.symbol}` : `${settings.symbol} ${formatAmount(carTypeObj.rate_per_hour, settings.decimal, settings.country)}` },
    { key: 'min_fare', label: t('min_fare'), value: settings.swipe_symbol ? `${formatAmount(carTypeObj.min_fare, settings.decimal, settings.country)} ${settings.symbol}` : `${settings.symbol} ${formatAmount(carTypeObj.min_fare, settings.decimal, settings.country)}` },
    { key: 'fleet_admin_fee', label: t('fleet_admin_fee'), value: settings.swipe_symbol ? `${formatAmount(carTypeObj.fleet_admin_fee, settings.decimal, settings.country)} ${settings.symbol}` : `${settings.symbol} ${formatAmount(carTypeObj.fleet_admin_fee, settings.decimal, settings.country)}` },
    { key: 'convenience_fees', label: t('convenience_fee'), value: carTypeObj.convenience_fee_type === 'flat'
      ? (settings.swipe_symbol
        ? `${formatAmount(carTypeObj.convenience_fees, settings.decimal, settings.country)} ${settings.symbol}`
        : `${settings.symbol} ${formatAmount(carTypeObj.convenience_fees, settings.decimal, settings.country)}`)
      : carTypeObj.convenience_fee_type === 'percentage'
        ? `${carTypeObj.convenience_fees} %`
        : '' },
    { key: 'parcel_type_web', label: t('parcel_type_web'), value: booking.parcelTypeSelected
      ? `${t(getLangKey(booking.parcelTypeSelected.description))} ${settings.swipe_symbol
      ? `(${booking.parcelTypeSelected.amount}${settings.symbol})`
      : `(${settings.symbol}${booking.parcelTypeSelected.amount})`
      }`
      : '' },
    { key: 'parcel_option', label: t('parcel_option'), value: booking.optionSelected
      ? `${t(getLangKey(booking.optionSelected.description))} ${settings.swipe_symbol
        ? `(${booking.optionSelected.amount}${settings.symbol})`
        : `(${settings.symbol}${booking.optionSelected.amount})`
      }`
      : '' },
  ];
}

function formatAmount(value, decimal, country) {
  const number = parseFloat(value || 0);
  if (country === 'Vietnam') {
    return number.toLocaleString('vi-VN', {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
  } else {
    return number.toLocaleString('en-US', {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
  }
}
